import React, {  } from 'react'
import { Box, Grid, Link, TextField, MenuItem, BottomNavigationAction } from '@material-ui/core';
import { useStore } from '../../Store'
import Header from '../Header'
import ActionBar from '../ActionBar';
import SaveIcon from '@material-ui/icons/Save';
import { getErrorProps } from '../../utils';

const ObservationDetails = ({ readonly, formik, handleCancel, handleSubmit }) => {
    const { plots, settings } = useStore()

    const taxLisTaxId = `observation.taxLisTaxId`
    const description = `observation.description`
    const abundance = `observation.abundance`

    const getTaxa = () => {
        const plot = plots.find(p => p.id === formik.values.plot)
        const taxaList = settings.taxaLists.find(t => t.id === plot.taxaListId)
        return taxaList.taxa.filter(t => t.type === 'row').sort((a, b) => a.sortorder > b.sortorder ? 1 : -1)
    }

    const taxa = getTaxa();

    const species = () => {
        return taxa.map(item => {
            return (
                <MenuItem key={item.id} value={item.id}>
                    {item.name}
                </MenuItem>
            )
        })
    }
    const changeTaxLisTaxId = (e) => {
        const item = taxa.find(t => t.id === e.target.value)
        // afhandeling reeds bestaande waarneming!?
        const observation= formik.values.observations.find(o => o.taxLisTaxId === item.id)
        if (observation) {
            formik.setFieldValue('observation', JSON.parse(JSON.stringify(observation)))
        }
        formik.setFieldValue(description, item ? item.name : "")
        formik.handleChange(e)
    }

    return (
        formik.values.observation &&
        <>
            <Header title={formik.values.observation.description || 'Nieuwe waarneming'} backAction={handleCancel} />
            <Box m={2}>
                <Grid container>

                    <Grid item xs={12}>
                        <TextField required select disabled={readonly} label="soort" variant="standard" name={taxLisTaxId} fullWidth
                            {...formik.getFieldProps(taxLisTaxId)}
                            onChange={changeTaxLisTaxId}
                            {...getErrorProps(formik, taxLisTaxId)}
                        >
                            {species()}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField required disabled={readonly} label="aantal" variant="standard" name={abundance} fullWidth type="tel" {...getErrorProps(formik, abundance)} {...formik.getFieldProps(abundance)} />
                    </Grid>

                </Grid>
            </Box>
            {!readonly &&
                <ActionBar>
                    {!readonly && <BottomNavigationAction label="Waarneming opslaan" component={Link} to="/" onClick={handleSubmit} style={{ color: '#00547d' }} icon={<SaveIcon />} />}
                </ActionBar>}
        </>
    )
}

export default ObservationDetails
